import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const DECO_TOP = ["Tambah Pemain", "Nama Pemain", "Nama Pemain Lama", "Newmember", "Referral", "Payment Gateway"];
const DECO_AFTER = ["Bank List", "Lupa Password", "Cash"];
const DECO_LAPORAN = ["History Transaksi", "Harian Pemain", "Pendapatan", "Laporan Depo WD", "Transaksi Lengkap"];
const DECO_PERANGKAT = ["Memo", "Memo Tools", "Member Online", "Catatan Log", "Ganti Password"];
const DECO_DOMAINS = ["Domains", "Redirect"];
const DECO_ACCOUNT = ["Overview", "Privacy", "Pengaturan"];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isStaff = user.role === "staff";
  const isSuper = user.role === "super_admin";
  const isTrainer = user.role === "trainer" || isSuper;
  const username = user.email.split("@")[0];

  const handleLogout = async () => { await logout(); navigate("/login"); };
  const deco = () => toast.info("Modul tidak tersedia dalam mode training");
  const Deco = ({ label }) => <a className="side-link" onClick={deco} data-testid={`deco-${label}`}>{label}</a>;
  const nav = (to, label, tid, end) => (
    <NavLink to={to} end={end} className={({ isActive }) => "side-link" + (isActive ? " active" : "")} data-testid={tid}>{label}</NavLink>
  );

  // ---- STAFF: minimal sidebar ----
  if (isStaff) {
    return (
      <div className="sidebar" data-testid="sidebar">
        <div className="agent-head"><span>Agent</span><span className="pga-badge">PGA ON</span></div>
        <div className="agent-sub"><div className="agent-code">({username})</div><div className="agent-name">TRAINING.COM</div></div>
        <div className="side-section">Transaksi</div>
        {nav("/", "Transaksi Baru", "menu-transaksi-baru", true)}
        <div className="side-section">Account</div>
        {nav("/history", "History Koin", "menu-history-koin")}
        <a className="side-link" onClick={handleLogout} data-testid="menu-logout">Keluar</a>
      </div>
    );
  }

  // ---- TRAINER / SUPER_ADMIN: full panel + management ----
  return (
    <div className="sidebar" data-testid="sidebar">
      <div className="agent-head"><span>Agent</span><span className="pga-badge">PGA ON</span></div>
      <div className="agent-sub"><div className="agent-code">({username})</div><div className="agent-name">TRAINING.COM</div></div>

      {DECO_TOP.map((l) => <Deco key={l} label={l} />)}
      {nav("/", "Transaksi Baru", "menu-transaksi-baru", true)}
      {DECO_AFTER.map((l) => <Deco key={l} label={l} />)}

      <div className="side-section train">Training</div>
      {isTrainer && nav("/data-training", "Data Training", "menu-data-training")}
      {isTrainer && nav("/training-control", "Training Control", "menu-training-control")}
      {isTrainer && nav("/training-result", "Training Result", "menu-training-result")}

      {isSuper && (
        <>
          <div className="side-section train" style={{ background: "#5c6bc0", color: "#fff", borderColor: "#3f51b5" }}>Management</div>
          {nav("/website-management", "Website Management", "menu-website-management")}
          {nav("/user-management", "User Management", "menu-user-management")}
        </>
      )}

      <div className="side-section">Rolling*</div>
      <div style={{ padding: "3px 6px" }}>
        <select className="side-select" defaultValue="" onChange={deco}><option value="">Pilih Pasar</option></select>
      </div>
      <div className="side-section">Laporan</div>
      {DECO_LAPORAN.map((l) => <Deco key={l} label={l} />)}
      <div className="side-section">Perangkat</div>
      {DECO_PERANGKAT.map((l) => <Deco key={l} label={l} />)}
      <div className="side-section">Domains</div>
      {DECO_DOMAINS.map((l) => <Deco key={l} label={l} />)}
      <div className="side-section">Account</div>
      {DECO_ACCOUNT.map((l) => <Deco key={l} label={l} />)}
      {nav("/history", "History Koin", "menu-history-koin")}
      <a className="side-link" onClick={handleLogout} data-testid="menu-logout">Keluar</a>
    </div>
  );
}
